<section id="info">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 info-top-text">
                <h2 class="mt-4">Why book with us?</h2>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-4 info-block-left">
                <div class="info-text">
                    <h3>Deep Discounts On Private Charters</h3>
                    <div class="block-line">
                        <div class="line"></div>
                    </div>
                    <p>
                        The secret to our deeply discounted private jet airfare lies in the
                        bulk contracts that we negotiated directly with private charter
                        operators, all of which are supplied privately. This is how we get
                        you the absolute best price and value for private charter airfare.
                    </p>
                </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-4 info-block-center">
                <div class="info-text">
                    <h3>Superior White Glove Service</h3>
                    <div class="block-line">
                        <div class="line"></div>
                    </div>
                    <p>
                        Your personal travel manager will proactively maximize all private
                        fare discounts and loyalty benefits for your flight while providing
                        support in real time before, during, and after your trip. We handle
                        all aspects of your booking.
                    </p>
                </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-4 info-block-right">
                <div class="info-text">
                    <h3>What's The Catch?</h3>
                    <div class="block-line">
                        <div class="line"></div>
                    </div>
                    <p>
                        There is no catch! We utilize our private fares to provide massive
                        savings and expert customer service to create an outstanding booking
                        experience. Simply submit a flight request or give us a call - you
                        will be amazed by our white glove service and low prices.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
